import { createPortal } from 'react-dom';

const Portal = ({ children, portalId = 'widget' }) => {
  return createPortal(children, document.getElementById(portalId));
};

export default Portal;
